export const RouteConstants = {
	CREATE: 'create',
	SIGN: 'sign',
} as const;
